<template>
  <div class="ivu-input-center">
    <!-- ---头部--- -->
    <content-title title="购入使用电量表" />
    <!-- ---说明--- -->
    <write-instruction :instructionsList="instructionsList" />
    <div style="height: 10px" />
    <!-- ---自动计算--- -->
    <div class="add-btn" v-if="editOrView == 'edit'">
      <Button
        type="primary"
        style="background-color: #009FD9;border-color: #009FD9;margin-left:10px"
        @click="autoCalcu"
        :loading="btnLoading.autoCalcu"
      >自动计算</Button>
      <Button
        type="primary"
        style="background-color: #009FD9;border-color: #009FD9;margin-left:10px"
        @click="syncData"
        :loading="btnLoading.syncData"
      >重新同步数据</Button>
      <Button
        v-if="reportType === 'year'"
        type="primary"
        class="btn-c-common mg-l-10"
        @click="exportReport"
        :loading="btnLoading.exportReport"
      >导出</Button>
      <Upload v-if="reportType === 'year'" :before-upload="uploadReport" action>
        <Button type="primary" class="btn-c-common mg-l-10" :loading="btnLoading.uploadReport">导入</Button>
      </Upload>
    </div>
    <!-- ---table显示区域--- -->
    <Table
      border
      :columns="columns"
      :data="tableData"
      :disabled-hover="true"
      :height="windowHeight"
      :span-method="SpanCellMerge"
      :loading="tableLoading"
    >
      <template v-for="item in monthConfig" slot-scope="{ row, index }" :slot="item.month">
        <span :key="item.month" v-if="editOrView == 'edit'">
          <Input
            style="width:140px"
            type="number"
            :disabled="item.flag == 'N'"
            :key="item.month"
            v-if="canModifyKey.indexOf(row.infoItem)===-1"
            v-model="row[item.month]"
            @on-focus="handleFocus(row,item.month)"
            @on-blur="dataChange(row, index)"
          />
          <Input
            style="width:140px"
            type="number"
            :disabled="row.infoItem==='电网排放因子' || item.flag == 'N'"
            v-else
            class="input-call"
            v-model="row[item.month]"
            @on-focus="handleFocus(row,item.month)"
            @on-blur="dataChange(row, index)"
          />
        </span>
        <span v-else :key="item.month">
          <span>{{ row[item.month] }}</span>
        </span>
        <MonitorAuditPrompt
          :key="item.month + 'prompt'"
          v-if="MonitorAuditPromptShow(row.unitName, row.infoItem,row.fuelName, item.month)"
          :concreteData="monitorAuditList"
          :contrastData="{...row,fieldName: item.month}"
          :type="3"
          :from="'report2'"
        />
      </template>
      <template slot-scope="{ row, index }" slot="total">
        <span v-if="editOrView == 'edit'">
          <Input
            style="width:140px"
            type="number"
            :disabled="row.infoItem==='电网排放因子'"
            v-model="row.total"
            class="input-call"
            @on-focus="handleFocus(row,'total')"
            @on-blur="dataChange(row, index)"
          />
        </span>
        <span v-else>{{row.total}}</span>
        <MonitorAuditPrompt
          v-if="MonitorAuditPromptShow(row.unitName, row.infoItem,row.fuelName, 'total')"
          :concreteData="monitorAuditList"
          :contrastData="{...row,fieldName: 'total'}"
          :type="3"
          :from="'report2'"
        />
      </template>
    </Table>
    <!-- ---底部按钮组--- -->
    <save-next
      v-if="editOrView == 'edit'"
      :btnLoading="btnLoading"
      @on-save="save('save')"
      @go-next="nextPage"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import contentTitle from "@/components/comment/content-title.vue";
import writeInstruction from "@/components/comment/write-instruction.vue";
import saveNext from "@/components/comment/save-next.vue";

import { decimalDigits } from "@/lib/util";
import {
  getMeterUseUnitInfoList,
  saveMeterUseData,
  cacuMeterUseData,
  syncMeterUseUnitInfoList,
  getReportAuditInfoService,
  createReportAuditInfoService
} from "@/api/emissions-report";
import MonitorAuditPrompt from "@/components/monitorAuditPrompt";

import { exportMeterUse, importMeterUse } from "@/api/file";

export default {
  name: "productCapacity",
  components: {
    contentTitle,
    writeInstruction,
    saveNext,
    MonitorAuditPrompt
  },
  data() {
    return {
      monitorAuditList: {},
      // 自动计算可手动修改的值
      canModifyKey: ["电网排放因子", "购入电力排放"],
      tableLoading: false,
      btnLoading: {
        autoCalcu: false,
        syncData: false,
        saveUnit: false,
        nextPage: false,
        exportReport: false,
        uploadReport: false
      },
      // 合并行/列
      merge1: [],
      pos1: 0,
      instructionsList: [
        "1、如果购入使用电量无法分机组，可按机组数目平分。",
        "2、购入使用电量保留到小数点后三位；购入使用电力对应的排放量保留到小数点后两位。"
      ],

      columns: [
        {
          title: "机组名称",
          key: "unitName",
          align: "center",
          fixed: "left",
          width: 100
        },
        {
          title: "参数名称",
          key: "infoItem",
          align: "center",
          fixed: "left",
          width: 160
        },
        {
          title: "单位",
          key: "unit",
          align: "center",
          fixed: "left",
          width: 120
        }
      ],
      year: [
        {
          title: "1月",
          slot: "january",
          align: "center",
          width: 210
        },
        {
          title: "2月",
          slot: "february",
          align: "center",
          width: 210
        },
        {
          title: "3月",
          slot: "march",
          align: "center",
          width: 210
        },
        {
          title: "4月",
          slot: "april",
          align: "center",
          width: 210
        },
        {
          title: "5月",
          slot: "may",
          align: "center",
          width: 210
        },
        {
          title: "6月",
          slot: "june",
          align: "center",
          width: 210
        },
        {
          title: "7月",
          slot: "july",
          align: "center",
          width: 210
        },
        {
          title: "8月",
          slot: "august",
          align: "center",
          width: 210
        },
        {
          title: "9月",
          slot: "september",
          align: "center",
          width: 210
        },
        {
          title: "10月",
          slot: "october",
          align: "center",
          width: 210
        },
        {
          title: "11月",
          slot: "november",
          align: "center",
          width: 210
        },
        {
          title: "12月",
          slot: "december",
          align: "center",
          width: 210
        }
      ],
      tableData: [],
      monthConfig: [
        { quarter: "1", month: "january", flag: "Y" },
        { quarter: "1", month: "february", flag: "Y" },
        { quarter: "1", month: "march", flag: "Y" },
        { quarter: "2", month: "april", flag: "Y" },
        { quarter: "2", month: "may", flag: "Y" },
        { quarter: "2", month: "june", flag: "Y" },
        { quarter: "3", month: "july", flag: "Y" },
        { quarter: "3", month: "august", flag: "Y" },
        { quarter: "3", month: "september", flag: "Y" },
        { quarter: "4", month: "october", flag: "Y" },
        { quarter: "4", month: "november", flag: "Y" },
        { quarter: "4", month: "december", flag: "Y" }
      ]
    };
  },
  async created() {
    await this.getList();
    // 报表为年报时
    if (this.reportType == "year") {
      let temp = [
        {
          title: "全年合计",
          slot: "total",
          align: "center",
          width: 210
        }
      ];
      this.columns = [...this.columns, ...this.year, ...temp];
    } else {
      // 报表为月报时
      this.monthConfig = [{ month: "itemVal", flag: "Y" }];
      this.columns.push({
        title: "数值",
        slot: "itemVal",
        align: "center"
      });
    }
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    reportId() {
      return this.getUserInfo.user.reportId;
    },
    windowHeight() {
      return window.innerHeight - 224;
    },
    companyId() {
      return this.getUserInfo.user.companyId;
    },
    editOrView() {
      return this.getUserInfo.user.editOrView;
    },
    reportType() {
      return this.getUserInfo.user.reportType;
    }
  },
  methods: {
    async createReportAuditInfoServiceFunc(type) {
      if (this.reportType === "year") {
        await createReportAuditInfoService({
          reportId: this.reportId,
          type: 3
        }).then(res => {
          if (type !== "noGet") {
            this.getReportAuditRecordInfoService(3);
          }
          this.getReportAuditRecordInfoService();
        });
      }
    },
    async getReportAuditRecordInfoService(type) {
      let params = {
        reportId: this.reportId,
        type: type ? type : "" //1-企业基本信息
      };
      await getReportAuditInfoService(params).then(async res => {
        if (this.reportType === "year") {
          if (type === 3) {
            this.monitorAuditList = res.body || {};
          } else {
            this.$store.dispatch("monitorAuditRecord/reportMapInfo", res.body);
          }
        } else {
          this.monitorAuditList = {};
        }
      });
    },
    async getList() {
      this.tableLoading = true;
      let params = {
        reportId: this.reportId,
        companyId: this.companyId
      };
      const { body } = await getMeterUseUnitInfoList(params);
      this.tableData = body.resultList;
      this.dataProcessing();
      this.getReportAuditRecordInfoService(3);
      this.tableLoading = false;
    },
    // 自动计算
    async autoCalcu() {
      this.btnLoading.autoCalcu = true;
      this.tableData.map(item => {
        item.reportId = this.reportId;
      });
      let params = {
        reportId: this.reportId,
        datas: this.tableData
      };
      await cacuMeterUseData(params);
      await this.createReportAuditInfoServiceFunc("noGet");
      await this.getList();
      this.btnLoading.autoCalcu = false;
    },
    // 重新同步数据
    async syncData() {
      this.tableLoading = true;
      this.btnLoading.syncData = true;
      let params = {
        companyId: this.companyId,
        reportId: this.reportId
      };
      const { body } = await syncMeterUseUnitInfoList(params);
      this.tableData = body.resultList;
      this.dataProcessing();
      this.createReportAuditInfoServiceFunc();
      this.tableLoading = false;
      this.btnLoading.syncData = false;
    },
    dataProcessing() {
      this.tableData.map(item => {
        if (item.infoItem.indexOf("消费的购入电量") != -1) {
          decimalDigits(item, 3, this.reportType);
        }
        if (item.infoItem.indexOf("购入电力排放") != -1) {
          decimalDigits(item, 2, this.reportType);
        }
      });
      this.getSpanArr(this.tableData, "unitName");
    },
    // 赋值操作
    dataChange(row, index) {
      this.numChange(row);
      this.tableData[index] = row;
    },
    numChange(data) {
      if (data.infoItem.indexOf("消费的购入电量") != -1) {
        decimalDigits(data, 3, this.reportType);
      }
      if (data.infoItem.indexOf("购入电力排放") != -1) {
        decimalDigits(data, 2, this.reportType);
      }
      if (data.infoItem.indexOf("电网排放因子") != -1) {
        decimalDigits(data, 4, this.reportType);
      }
    },
    handleFocus(row, key) {
      if (Number(row[key]) === 0) {
        row[key] = "";
      }
    },
    // 合并列表
    getSpanArr(data, key1, key2) {
      let num = 0;
      if (key2 == undefined) {
        num = 1;
      } else {
        num = 2;
      }
      this[`merge${num}`] = [];
      this[`pos${num}`] = "";
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this[`merge${num}`].push(1);
          this[`pos${num}`] = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          //根据相同key进行合并,根据需要可进行修改
          let temp;
          if (key2 != undefined) {
            temp =
              data[i][key2] === data[i - 1][key2] &&
              data[i][key1] === data[i - 1][key1];
          }
          if (key2 == undefined) {
            temp = data[i][key1] === data[i - 1][key1];
          }
          if (temp) {
            this[`merge${num}`][this[`pos${num}`]] += 1;
            this[`merge${num}`].push(0);
          } else {
            this[`merge${num}`].push(1);
            this[`pos${num}`] = i;
          }
        }
      }
    },
    SpanCellMerge({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.merge1[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    async nextPage() {
      await this.save("next");
      this.$router.push({
        path: "/report/report2-1"
      });
    },
    async save(type) {
      if (type === "save") {
        this.btnLoading.saveUnit = true;
      } else {
        this.btnLoading.nextPage = true;
      }
      this.tableData.map(item => {
        item.reportId = this.reportId;
      });
      let params = {
        reportId: this.reportId,
        datas: this.tableData
      };
      await saveMeterUseData(params).then(async res => {
        await this.createReportAuditInfoServiceFunc("noGet");
        if (type === "save") {
          await this.getList();
          this.$Message.success("保存成功");
          this.btnLoading.saveUnit = false;
        } else {
          this.btnLoading.nextPage = false;
        }
      });
    },
    MonitorAuditPromptShow(unitName, infoItem, fuelName, fieldName) {
      const O_index = this.monitorAuditList.O
        ? this.monitorAuditList.O.findIndex(
            item =>
              item.unitName == unitName &&
              item.infoItem == infoItem &&
              item.fuelName == fuelName &&
              item.fieldName == fieldName
          )
        : -1;
      const Y_index = this.monitorAuditList.Y
        ? this.monitorAuditList.Y.findIndex(
            item =>
              item.unitName == unitName &&
              item.infoItem == infoItem &&
              item.fuelName == fuelName &&
              item.fieldName == fieldName
          )
        : -1;
      const N_index = this.monitorAuditList.N
        ? this.monitorAuditList.N.findIndex(
            item =>
              item.unitName == unitName &&
              item.infoItem == infoItem &&
              item.fuelName == fuelName &&
              item.fieldName == fieldName
          )
        : -1;
      const arr = [O_index, Y_index, N_index];
      let flag = arr.filter(item => {
        return item !== -1;
      });
      return flag.length !== 0;
    },
    exportReport() {
      this.btnLoading.exportReport = true;
      let params = { reportId: this.reportId };
      exportMeterUse(params).then(res => {
        let headers = res.headers;
        const fileName = decodeURI(
          headers["content-disposition"].split("filename=")[1]
        ).replace(/\"/g, "");
        const content = res.data;
        const blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
        this.btnLoading.exportReport = false;
      });
    },
    uploadReport(file) {
      this.btnLoading.uploadReport = true;
      let params = {
        file: file,
        reportId: this.reportId
      };
      importMeterUse(params).then(res => {
        if (res.data.status === 200) {
          this.$Message.success("导入成功");
          this.getList();
        } else {
          this.$Message.error(res.data.message);
        }
        this.btnLoading.uploadReport = false;
      });
      return false;
    }
  }
};
</script>

<style lang="less" scoped>
</style>
